import React from "react";
import Iconify from "../../components/Iconify";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const getIcon = (name) => <Iconify icon={name} width={20} height={20} />;

export const SideBarConfig = () => {
  let sidebarMenus = [];

  sidebarMenus.push({
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  });
  sidebarMenus.push({
    title: "User Management",
    path: "/user-management",
    icon: getIcon("eva:person-fill"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Employee Management",
    path: "/employee-management",
    icon: getIcon("mdi:account-group"),
    badge: false,
  });

  sidebarMenus.push({
    title: "Business Center",
    path: "/business-center",
    icon: getIcon("mdi:office-building"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Agency Accounts",
    path: "/agency-accounts",
    icon: getIcon("mdi:domain"),
    badge: true,
  });

  sidebarMenus.push({
    title: "Product List",
    path: "/product-list",
    icon: getIcon("mdi:shopping-outline"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Cancel Subscriptions",
    path: "/cancel-subscription-requests",
    icon: getIcon("tabler:basket-cancel"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Transactions List",
    path: "/transactions-list",
    icon: getIcon("mdi:bank-transfer"),
    badge: false,
  });

  let payment_child_array = [];

  payment_child_array.push({
    title: "Wallet Transactions",
    path: "/wallet-transactions",
    icon: getIcon("mdi:bank-transfer"),
  });
  payment_child_array.push({
    title: "Deposit Request",
    path: "/deposit-request",
    icon: getIcon("mdi:cash-plus"),
  });

  payment_child_array.push({
    title: "Clear Wallet Balance",
    path: "/clear-wallet-balance",
    icon: getIcon("mdi:cash-plus"),
  });

  sidebarMenus.push({
    title: "Wallet Management",
    icon: <PaymentsOutlinedIcon />,
    child_options: payment_child_array,
  });
  sidebarMenus.push({
    title: "CC Authorization",
    path: "/cc-authorization",
    icon: getIcon("simple-icons:adguard"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Appeal Disabled Account",
    path: "/appeal-disabled-account",
    icon: getIcon("mdi:account-alert"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Top Up Funds",
    path: "/top-up-funds",
    icon: getIcon("mdi:credit-card-plus"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Clear Account Funds",
    path: "/clear-account-funds",
    icon: getIcon("mdi:bank-remove"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Affiliate Payout Request",
    path: "/affiliate-payout-request",
    icon: getIcon("mdi:briefcase-check"),
    badge: false,
  });
  sidebarMenus.push({
    title: "Support",
    icon: getIcon("ic:round-support-agent"),
    child_options: [
      {
        title: "Support Tickets",
        path: "/support-ticket",
        icon: getIcon("ic:round-task-alt"),
      },
    ],
  });
  sidebarMenus.push({
    title: "Settings",
    icon: getIcon("mdi:cog"),
    badge: false,
    child_options: [
      {
        title: "General Settings",
        path: "/general-settings",
        icon: getIcon("mdi:cog"),
        badge: false,
      },
      {
        title: "Stripe Settings",
        icon: getIcon("mdi:cog"),
        path: "/stripe-settings",
        badge: false,
      },
    ],
  });
  sidebarMenus.push({});

  return sidebarMenus;
};
